'worklet';

// getTagPriority returns a priority for a tag, higher priority means the tag should be processed first
function getTagPriority(tag) {
  switch (tag) {
    case 'blockquote':
      return 2;
    case 'h1':
      return 1;
    default:
      return 0;
  }
}
function sortRanges(ranges) {
  // sort ranges by start position, then by length, then by tag hierarchy
  return ranges.sort((a, b) => a.start - b.start || b.length - a.length || getTagPriority(b.type) - getTagPriority(a.type) || 0);
}
function groupRanges(ranges) {
  const lastVisibleRangeIndex = {};
  return ranges.reduce((acc, range) => {
    const start = range.start;
    const end = range.start + range.length;
    const rangeWithSameStyleIndex = lastVisibleRangeIndex[range.type];
    const sameStyleRange = rangeWithSameStyleIndex !== undefined ? acc[rangeWithSameStyleIndex] : undefined;
    if (sameStyleRange && sameStyleRange.start <= start && sameStyleRange.start + sameStyleRange.length >= end && range.length > 1) {
      // increment depth of overlapping range
      sameStyleRange.depth = (sameStyleRange.depth || 1) + 1;
    } else {
      lastVisibleRangeIndex[range.type] = acc.length;
      acc.push(range);
    }
    return acc;
  }, []);
}
function ungroupRanges(ranges) {
  const ungroupedRanges = [];
  ranges.forEach(range => {
    if (!range.depth) {
      ungroupedRanges.push(range);
    }
    const {
      depth,
      ...rangeWithoutDepth
    } = range;
    Array.from({
      length: depth
    }).forEach(() => {
      ungroupedRanges.push(rangeWithoutDepth);
    });
  });
  return ungroupedRanges;
}
function splitRangesOnEmojis(ranges, type) {
  const emojiRanges = ranges.filter(range => range.type === 'emoji');
  const newRanges = [];
  let i = 0;
  let j = 0;
  while (i < ranges.length) {
    const currentRange = ranges[i];
    if (!currentRange) {
      break;
    }
    if (currentRange.type !== type) {
      newRanges.push(currentRange);
      i++;
    } else {
      // Iterate through all emoji ranges before the end of the current range, splitting the current range at each intersection.
      while (j < emojiRanges.length) {
        const emojiRange = emojiRanges[j];
        if (!emojiRange || emojiRange.start > currentRange.start + currentRange.length) {
          break;
        }
        const currentStart = currentRange.start;
        const currentEnd = currentRange.start + currentRange.length;
        const emojiStart = emojiRange.start;
        const emojiEnd = emojiRange.start + emojiRange.length;
        if (emojiStart >= currentStart && emojiEnd <= currentEnd) {
          // Intersection
          const newRange = {
            type: currentRange.type,
            start: currentStart,
            length: emojiStart - currentStart,
            ...((currentRange === null || currentRange === void 0 ? void 0 : currentRange.depth) && {
              depth: currentRange === null || currentRange === void 0 ? void 0 : currentRange.depth
            })
          };
          currentRange.start = emojiEnd;
          currentRange.length = currentEnd - emojiEnd;
          if (newRange.length > 0) {
            newRanges.push(newRange);
          }
        }
        j++;
      }
      if (currentRange.length > 0) {
        newRanges.push(currentRange);
      }
      i++;
    }
  }
  return newRanges;
}
export { sortRanges, groupRanges, ungroupRanges, splitRangesOnEmojis };
//# sourceMappingURL=rangeUtils.js.map